import { defineStore, getActivePinia } from 'pinia'

import { state } from './state'

export const mainStore = () => {
  const init = defineStore('favoritesMain', {
    state,
  })

  return init(getActivePinia())
}
